<template>
  <v-col
    class="pb-4"
    cols="12"
    sm="6"
    md="4"
    lg="3"
  >
    <div
      :class="['rounded image cursor-pointer', { 'image-hover': $display.mdAndUp.value }]"
      :title="`Открыть ${title}`"
      @click="handlePreviewClick"
    >
      <v-img
        class="elevation-1 rounded"
        :src="previewSrc"
        :srcset="previewSrcset"
        :height="$display.mdAndUp.value ? 240 : 300"
        cover
      />
      <v-btn
        color="ui-kit-bg-gray-0"
        size="40"
        class="image-button"
        rounded="circle"
        :title="`Открыть ${title}`"
        icon
      >
        <v-icon
          v-if="$display.mdAndUp.value"
          color="primary"
        >
          ui-icon-eye-open
        </v-icon>
      </v-btn>
    </div>
    <p class="text-body-2 text-ui-kit-text-secondary text-center mb-0 mt-2 mt-md-4">
      {{ title }}
    </p>
  </v-col>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

const props = defineProps({
  href: { type: String, required: true },
  title: { type: String, required: true },
  previewSrc: { type: String, required: true },
  previewSrcset: { type: String, default: '' },
})

const $display = useDisplay()

function handlePreviewClick() {
  window.open(props.href, '_blank')
}
</script>

<style lang="scss" scoped>
@use '@/assets/vuetify/settings';
@use 'sass:map';

.image {
  position: relative;
}

.image-hover {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    inset: 0;
    background: rgba($t-ui-icon-primary, 0.4);
    opacity: 0;
    transition: opacity .3s;
    border-radius: 4px;
    pointer-events: none;
  }

  &:hover {
    &::before,
    .image-button {
      opacity: 1;
    }
  }
}

.image-button {
  @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  position: absolute;
  z-index: 2;
  opacity: 0;
}
</style>

